module.exports = __webpack_public_path__ + "media/images/bg_mv_purchasing_apartment-8603ff77a47e3a47700157bd9bee9783.jpg";